import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function getRejectedNotesCount(): Promise<number> {
  const { documents_count } = await cosignatureRequestsTyped.get_rejected_notes_count();

  return documents_count;
}
